import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { cn } from '@/src/util/ui';

type AttachmentsCountProps = {
  count: number;
  buttonClassSettings?: {
    variant: string;
    size?: string;
    weight?: string;
    isActive?: boolean;
    activeStyles?: string;
  };
  className?: string;
  onClick?: () => void;
};

const AttachmentsCount = ({
  count,
  buttonClassSettings = {
    variant: 'inverse',
    size: 'sm',
    weight: 'bold',
  },
  className,
  onClick,
}: AttachmentsCountProps) => {
  const displayCount = count > 1000 ? ' 999+' : ' ' + count;

  return (
    <Button className={cn(className)} buttonClassSettings={buttonClassSettings} onClick={onClick}>
      <Icon className={clsx('tw-rotate-45', 'tw-text-[16px]')} icon={ICONS.attach} /> -
      {displayCount}
    </Button>
  );
};

export default AttachmentsCount;
